/*global Synapse*/
import { useState } from 'react';
import Box from '@mui/material/Box';
import { Button, CircularProgress, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { Sophtron } from '../OverviewSection/Accounts/banklinking/Sophtron';

export default function ReconnectBankComponent(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [shown, setShown] = useState(false);

    const onComplete = () => {
        window.location.reload();
        setShown(false);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#F655701A',
                height: '40px',
                borderRadius: '4px'
            }}>
            <CancelIcon sx={{ color: '#F65570', marginRight: '10px' }} />
            <Typography
                sx={{
                    fontFamily: 'Montserrat',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    fontSize: '13px',
                    lineHeight: '20px',
                    color: '#182D55'
                }}>
                Your primary bank account is disconnected. Please reconnect it to unlock all the cards.
            </Typography>
            <Button
                sx={{
                    fontFamily: 'Montserrat',
                    fontStyle: 'normal',
                    fontWeight: 'bold',
                    fontSize: '13px',
                    lineHeight: '20px',
                    color: '#F65570',
                    marginLeft: '10px',
                    textDecoration: 'none'
                }}
                disabled={isLoading}
                onClick={() => setShown(!shown)}>
                {isLoading ? <CircularProgress size="20px" /> : 'CONNECT NOW'}
            </Button>
            {shown ? <Sophtron shown={shown} setShown={setShown} onComplete={onComplete} reconnect={true} /> : null}
        </Box>
    );
}
